module.exports = __webpack_public_path__ + "static/media/partnerships-mobile.2b7fd1e7.svg";